import { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';

// Hook to use auth context
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};

// Hook to check if authenticated (has website token)
export const useIsAuthenticated = () => {
    const { isAuthenticated } = useAuth();
    return isAuthenticated;
};

// Hook to get the website token
export const useToken = () => {
    const { token } = useAuth();
    return token;
};

// Hook to check if user can edit (has token)
export const useCanEdit = () => {
    const { isAuthenticated } = useAuth();
    return isAuthenticated;
};

export default {
    useAuth,
    useIsAuthenticated,
    useToken,
    useCanEdit,
};
